/* Forged Racing — algorithmic flag emojis from ISO 3166-1 alpha-2 codes.
   Regional-indicator math: no hardcoded flag table needed. */
(function () {
  'use strict';

  window.ForgedFlag = {
    emoji: function (code) {
      if (!code || code.length !== 2) return '';
      var OFFSET = 0x1f1e6 - 65;
      var c = code.toUpperCase();
      return String.fromCodePoint(c.charCodeAt(0) + OFFSET, c.charCodeAt(1) + OFFSET);
    },
    hydrate: function (root) {
      (root || document).querySelectorAll('[data-flag]').forEach(function (el) {
        if (!el.textContent.trim()) el.textContent = window.ForgedFlag.emoji(el.dataset.flag);
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.ForgedFlag.hydrate();
    });
  } else {
    window.ForgedFlag.hydrate();
  }
})();
